import gql from 'graphql-tag';

import client from '../graphqlAPI';

const GET_POSTS_BY_CATEGORY = gql`
  query Get($category: String!, $language: String, $search: String) {
    getPostsByCategory(category: $category, language: $language, search: $search) {
      isAuth
      posts {
        _id
        slugName
        postName
        postCategory
        type
        active
        postDescription {
          title {
            en
            es
            ca
            pt
          }
        }
      }
    }
  }
`;

const getPostsByCategory = async (category, language = "en", search = "") => {
  try {
    const result = await client
      .query({
        query: GET_POSTS_BY_CATEGORY,
        variables: { category, language, search },
        errorPolicy: 'all',
        fetchResults: true,
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { getPostsByCategory: postsByCategoryData },
    } = result;

    if (postsByCategoryData) {
      return postsByCategoryData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: getPostsByCategory = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: getPostsByCategory Error: ${error}`);
    return null;
  }
};

export default getPostsByCategory;
